import { ChangeDetectionStrategy, Component, computed, input, signal } from '@angular/core';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatIconModule } from '@angular/material/icon';
import { ProductIntegrationStatus } from '../../../enums';
import { ProductStatusComponent } from '../product-status/product-status.component';

@Component({
  selector: 'aionz-product-integration-accordion',
  imports: [
    MatExpansionModule,
    MatIconModule,
    ProductStatusComponent
  ],
  templateUrl: './product-integration-accordion.component.html',
  styleUrl: './product-integration-accordion.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ProductIntegrationAccordionComponent {
  public productCode = input.required<string>();
  public productName = input.required<string>();
  public ERPId = input<string | null | undefined>(undefined);
  public orderId = input<string | null | undefined>(undefined);
  public status = input.required<ProductIntegrationStatus>();
  public errorMessage = input<string | null>(null);
  public suppliers = input<string[]>([]);
  public costCenters = input<string[]>([]);
  public branches = input<string[]>([]);

  public opened = signal<boolean>(false);
  public isFailed = computed(() => this.status() === ProductIntegrationStatus.INTEGRATION_FAILED);
  public isSuccess = computed(() => this.status() === ProductIntegrationStatus.SUCCESSFULLY_INTEGRATED);
  public isPartial = computed(() => this.status() === ProductIntegrationStatus.PARTIALLY_INTEGRATED);

  /** Motivo do erro visível com o painel fechado; o texto completo fica no conteúdo expandido. */
  public errorSummary = computed(() => {
    if (this.isSuccess()) return null;
    const message = this.errorMessage()?.trim();
    return message ? message : null;
  });
}
